import sileo from 'sileo';

const Task = new sileo.Model('bposeats', 'task');
const TaskSkeleton = new sileo.Model('bposeats', 'task-summary');
const AmazonFormData = new sileo.Model('bposeats', 'issue-attachments-amazon-form-data');
const TaskHistory = new sileo.Model('bposeats', 'task-history');
const Mention = new sileo.Model('bposeats', 'mentions');
const TaskCounts = new sileo.Model('bposeats', 'task-counts');
const TaskComments = new sileo.Model('bposeats', 'task-comments');

const actions = {
    fetchIssueCounts(context, filters) {
        return TaskCounts.objects.filter(filters);
    },

    async createComment(context, data) {
        // create issue
        const form = new FormData();
        form.append('task_id', data.issueId);
        form.append('comment', data.comment);
        return await TaskComments.objects.create(form);
    },

    fetchComments(context, filters) {
        return TaskComments.objects.filter(filters);
    },

    async addAttachments(context, data) {
        return await Task.objects.update({
            pk: data.pk,
            attachments: JSON.stringify(data.attachments)
        });
    },

    async removeAttachments(context, data) {
        return await Task.objects.update({
            pk: data.pk,
            image_uuid: data.image_uuid,
            method: 'remove attachment'
        });
    },

    async updateIssue(context, data) {
        const form = new FormData();
        let filters = {};

        if (data.departmentIds) {
            form.append('departmentIds', JSON.stringify(data.departmentIds));
        }
        if (data.pk) {
            filters['pk'] = data.pk;
        }
        if (data.status) {
            filters['status'] = data.status;
        }
        if (data.task_list_pk) {
            filters['task_list_pk'] = data.task_list_pk;
        }
        if (Object.prototype.hasOwnProperty.call(data, 'is_approved')) {
            filters['is_approved'] = data.is_approved;
        }
        if (data.department_pk) {
            filters['department_pk'] = data.department_pk;
        }
        if (data.archive != null) {
            form.append('archive', data.archive);
        }
        if (data.rating != null) {
            form.append('rating', data.rating);
        }
        if (data.remarks != null) {
            form.append('remarks', data.remarks);
        }

        return await Task.objects.update(filters, form);
    },

    async fetchAmazonFormData() {
        return await AmazonFormData.objects.filter().then(amazon => {
            return amazon.amazon;
        });
    },

    async createIssue(context, data) {
        // create issue
        const form = new FormData();

        form.append('title', data.title);
        form.append('description', data.description);
        form.append('attachments', JSON.stringify(data.attachments));
        form.append('location', data.location);
        form.append('deadline', data.deadline);
        form.append('facility_name', data.facilityName);

        return await Task.objects.create(form).then((response) => {
            return response;
        }).catch(response => {
            console.error(response);
        });
    },

    fetchTaskHistory(context, filters) {
        return TaskHistory.objects.filter(filters);
    },

    fetchMentions(context, filters) {
        return Mention.objects.filter(filters);
    },

    fetchCardDetails(context, pk) {
        return Task.objects.get(pk);
    },

    fetchTaskSkeletonDetails(context, pk) {
        return TaskSkeleton.objects.get(pk);
    },
};

export default {
    namespaced: true,
    actions
};
